import axiosInstance from '../constants/axiosInstance';
import { visualizationPagesPathConstants } from '../pages/visualization/visualizationPages/visualizationPagesConstants';

interface ScadaPage {
  _id: string;
  name: string;
  type?: string;
}

const fetchScadaPages = async (workspaceId: string, query: string): Promise<ScadaPage[]> => {
  const { data } = await axiosInstance().post<{ data: { list: ScadaPage[] } }>(
    visualizationPagesPathConstants.listOfPagesVisulaization,
    { workspaceId, query, workspacePage: true }
  );
  return data.data?.list || [];
};

const setScadaDefaultView = async (
  workspaceId: string,
  defaultViewLink: string | null
): Promise<void> => {
  await axiosInstance().post('/visualization/setScadaDefaultView', {
    workspaceId,
    defaultViewLink,
  });
};

// Backend is the single source of truth for a workspace's default view.
// Returns the full default path/link (e.g. "plant-view/{ws}/{plantId}/{equipmentId}")
// so a default can be set at ANY level, or null if none is set.
const getScadaDefaultView = async (
  workspaceId: string
): Promise<string | null> => {
  const { data } = await axiosInstance().post<{
    status?: boolean;
    data?: { defaultViewLink?: string | null };
    message?: string;
  }>('/visualization/getScadaDefaultView', { workspaceId });
  return data?.data?.defaultViewLink ?? null;
};

export { fetchScadaPages, setScadaDefaultView, getScadaDefaultView };
export type { ScadaPage };
